import {apiAdonis} from '../../../services/api';

export const CustomersHTTP = {
  get: (params = {}) => apiAdonis.get('/customers', {params}),
  create: (payload = {}) => apiAdonis.post('/customers', payload),
  update: (id = '', params = {}) => apiAdonis.put(`/customers/${id}`, params),
};
